export enum RouterPattern {
  /** 各组件开发时的非线上数据 Storybook Layout 路由 */
  StorybookLayout = '/:project/.storybook/setting',
  /** Storybook 内部显示 iframe 用路由 */
  StorybookPage = '/:project/.storybook/setting/page/:storyFileId?',
}

export enum RouterKey {
  StorybookPage = 'Setting.StorybookPage',
}
